import { useRequiredContext } from "@suse-o11y/use-required-context";

import type { ApplicationDomain } from "~/models/dto";

import { ApplicationDomainContext } from "./_context";

export const useApplicationDomain = (): ApplicationDomain =>
	useRequiredContext(ApplicationDomainContext, { providerName: "ApplicationDomainContext" });
